import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51e52dd8")

_pushScopeId("data-v-51e52dd8")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "description" }, [
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", { class: "title" }, [
      /*#__PURE__*/_createVNode("h5", null, "操作指南：")
    ]),
    /*#__PURE__*/_createVNode("li", null, "1.安装应用"),
    /*#__PURE__*/_createVNode("li", null, "2.对订单进行发货，应用可以根据物流单号自动追踪物流信息"),
    /*#__PURE__*/_createVNode("li", null, "3.使用商城默认物流公司匹配度更高"),
    /*#__PURE__*/_createVNode("li", null, "4.用户在订单详情页可以查看发货物流轨迹")
  ])
], -1)
const _hoisted_3 = { class: "images" }
const _hoisted_4 = { class: "btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_page_header = _resolveComponent("m-page-header")
  const _component_m_image_preview = _resolveComponent("m-image-preview")
  const _component_el_button = _resolveComponent("el-button")
  const _component_m_form_skeleton = _resolveComponent("m-form-skeleton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_m_page_header, { title: "操作指南" })
    ]),
    _createVNode("main", null, [
      _createVNode(_component_m_form_skeleton, {
        loading: $setup.loading,
        type: "text"
      }, {
        default: _withId(() => [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_m_image_preview, {
              imgList: [$setup.homePreview2, $setup.homePreview3, $setup.homePreview4, $setup.homePreview5]
            }, null, 8, ["imgList"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: $setup.isInstall ? 'danger' : 'primary',
              onClick: $setup.setPlugin,
              loading: $setup.btnLoading,
              size: "medium"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString($setup.isInstall ? '卸载插件' : '安装插件'), 1)
              ]),
              _: 1
            }, 8, ["type", "onClick", "loading"])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
})